var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        { staticClass: "header-container" },
        [
          _c("v-spacer"),
          _vm._v(" "),
          _c("figure", [
            _c("img", {
              staticClass: "header-logo-image",
              attrs: { src: _vm.Logo },
            }),
            _vm._v(" "),
            _c("figcaption", [
              _c(
                "a",
                { staticClass: "header-sitename", attrs: { href: "/" } },
                [
                  _vm._v("\n          Material Management Portal\n          "),
                  _vm.isColorRed === true
                    ? _c("span", { class: { "lbl-red": _vm.isColorRed } }, [
                        _vm._v(
                          "\n            (" +
                            _vm._s(_vm.HeaderEnv) +
                            ")\n          "
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("v-spacer"),
        ],
        1
      ),
      _vm._v(" "),
      _vm.screenWidth > 720
        ? _c(
            "div",
            { staticClass: "header-toolbar-extension", attrs: { xs12: "" } },
            _vm._l(_vm.menuExtension, function (itemMain, index) {
              return _c(
                "v-menu",
                {
                  key: itemMain.label,
                  style: _vm.getPadding(itemMain.label),
                  attrs: {
                    "close-on-content-click": true,
                    transition: "slide-x-transition",
                    "min-width": "210px",
                    "offset-y": "",
                    lazy: "",
                    "open-on-click": "",
                    disabled: _vm.authLoading,
                    "nudge-left": "32px",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass:
                        "white--text header-toolbar-extension-btn font-gotham",
                      attrs: {
                        slot: "activator",
                        disabled: _vm.authLoading,
                        flat: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleNavigateLevel1(
                            itemMain.subGroup,
                            itemMain.target
                          )
                        },
                      },
                      slot: "activator",
                    },
                    [_vm._v("\n        " + _vm._s(itemMain.label) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-menu show-xs" }, [
                    _c("div", { staticClass: "small-nav-container" }, [
                      _c(
                        "div",
                        { staticClass: "small-nav small-nav-corp-links" },
                        [
                          _c(
                            "ul",
                            { staticClass: "list-unstyled icon-list" },
                            _vm._l(
                              _vm.menuExtension[index].subGroup,
                              function (itemSub) {
                                return _c(
                                  "li",
                                  {
                                    key: itemSub.label,
                                    staticClass: "menu-hover",
                                  },
                                  [
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: {
                                          "close-on-content-click": true,
                                          "min-width": "210px",
                                          "offset-x": "",
                                          "allow-overflow": "",
                                          "offset-overflow": "",
                                          lazy: "",
                                          "nudge-top": "6px",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "header-toolbar-extension-btn font-gotham",
                                            staticStyle: { width: "210px" },
                                            attrs: {
                                              slot: "activator",
                                              flat: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleNavigate(
                                                  itemSub.target
                                                )
                                              },
                                            },
                                            slot: "activator",
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(itemSub.label) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-menu show-xs",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "small-nav-container",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "small-nav small-nav-corp-links",
                                                  },
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        staticClass:
                                                          "header-toolbar-extension-btn font-gotham",
                                                        staticStyle: {
                                                          "min-width": "210px",
                                                        },
                                                        attrs: { flat: "" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleNavigate(
                                                              itemSub.target
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              itemSub.label
                                                            ) +
                                                            "\n                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.globalLoading
        ? _c(
            "div",
            { staticClass: "menu-fepmt-footer" },
            [
              _c("v-progress-linear", {
                staticStyle: { margin: "0px" },
                attrs: { id: "LoadingFEPMT", indeterminate: true, height: "7" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      this.screenWidth <= 720
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "navigation-drawer",
              attrs: {
                absolute: "",
                "hide-overlay": "",
                width: `${this.screenWidth <= 414 ? this.screenWidth : 350}`,
                height: "85vh",
              },
              model: {
                value: _vm.drawer,
                callback: function ($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer",
              },
            },
            [
              _vm._l(_vm.menuItems, function (item, index) {
                return _c(
                  "v-list",
                  { key: index },
                  [
                    item.target.name === "mainmenu"
                      ? _c(
                          "v-list-tile",
                          {
                            staticClass: "list-tile-hover",
                            on: {
                              click: function ($event) {
                                return _vm.InitializeMenuItems()
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "glyphicon glyphicon-chevron-left",
                            }),
                            _c("v-list-tile-title", {
                              staticClass: "font-gotham",
                              domProps: { textContent: _vm._s(item.label) },
                            }),
                          ],
                          1
                        )
                      : item.canback && item.target.name !== "mainmenu"
                      ? _c(
                          "v-list-tile",
                          {
                            staticClass: "list-tile-hover",
                            on: {
                              click: function ($event) {
                                return _vm.handleShowNextLevel(item.target.name)
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "glyphicon glyphicon-chevron-left",
                            }),
                            _c("v-list-tile-title", {
                              staticClass: "font-gotham",
                              domProps: { textContent: _vm._s(item.label) },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "v-list-tile",
                          {
                            staticClass: "list-tile-hover",
                            on: {
                              click: function ($event) {
                                return _vm.handleShowNextLevel(item.target.name)
                              },
                            },
                          },
                          [
                            _c("v-list-tile-title", {
                              staticClass: "font-gotham",
                              domProps: { textContent: _vm._s(item.label) },
                            }),
                            item.cannext
                              ? _c("span", {
                                  staticClass:
                                    "glyphicon glyphicon-chevron-right",
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "v-list",
                [
                  _c("hr", { staticClass: "hr-line" }),
                  _vm._v(" "),
                  _c("v-list-tile", [
                    _c("h3", { staticClass: "quick-links" }, [
                      _vm._v("quick links"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-list-tile", { staticClass: "list-tile-hover" }, [
                    _c(
                      "a",
                      {
                        staticClass: "list-tile-hover-icon font-gotham",
                        staticStyle: { "text-decoration": "none" },
                        attrs: {
                          href: "https://chevron.sharepoint.com/sites/ASBUTHITProFEPMT/Lists/In%20App%20Useful%20Links/AllItems.aspx",
                          target: "blank",
                        },
                      },
                      [_vm._v("useful link")]
                    ),
                  ]),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }